import { useEffect, useRef, useState } from 'react';
import BZAPIService from '../../../services/BZAPIService';
import { isManualComponents } from './fleetPanelData';

/**
 * Fetches the manual module list (union of affected_components on the project's
 * own issues) for a manually created project. Returns [] for any other project.
 * A generation token stops a slow response from landing on another project.
 */
export default function useManualComponents(project) {
  const [components, setComponents] = useState([]);
  const runIdRef = useRef(0);
  const projectId = project && project.id;
  const manual = isManualComponents(project);

  useEffect(() => {
    const runId = ++runIdRef.current;
    if (!manual || !projectId) {
      setComponents([]);
      return;
    }
    (async () => {
      try {
        const data = await BZAPIService.bsaInvGetManualComponents(projectId);
        if (runIdRef.current !== runId) return;
        setComponents((data && data.components) || []);
      } catch (e) {
        if (runIdRef.current !== runId) return;
        setComponents([]);
      }
    })();
  }, [projectId, manual]);

  return { manualComponents: components };
}
